export function validateEmail(email) {
  return email.match(
    /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,3}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b)$/
  );
}
